module.exports = __webpack_public_path__ + "257ab8481e3dc7b0b182873e61e94f38.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/drumsticks-s.png
// module id = 2516
// module chunks = 0